import PropTypes from 'prop-types';
import useAnalyticsEvent from '../../hooks/useAnalyticsEvent';

const DemoLink = ({ url }) => {
  const emitEvent = useAnalyticsEvent();

  // Using window.location.pathname because the article props are not available
  // to use here easily. Would need to pass down from the markdown file itself, which is
  // too much.
  const onClick = () => {
    emitEvent({
      action: 'demoLinkClick',
      category: 'demoLink',
      label: window?.location?.pathname,
    });
  };

  return (
    <div className="blog-content-btn">
      <a
        className="btn btn-primary"
        href={url}
        target="_blank"
        rel="noopener"
        onClick={onClick}
      >
        View Demo
      </a>
    </div>
  );
};

DemoLink.propTypes = {
  url: PropTypes.string.isRequired,
};

export default DemoLink;
